import { useId } from "react";

const STONE = "M76 212V108a52 52 0 0 1 104 0v104Z";

export function GraveIcon({ weight = "regular", className = "h-4 w-4", ...rest }) {
  const mask = useId();
  const sw = weight === "bold" ? 22 : weight === "light" ? 12 : weight === "thin" ? 8 : 16;
  const common = { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 256", className, fill: "none", stroke: "currentColor", strokeWidth: sw, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": true, ...rest };
  if (weight === "fill") {
    return (
      <svg {...common}>
        <defs>
          <mask id={mask}>
            <rect width="256" height="256" fill="white" />
            <path d="M128 92v72M104 116h48" stroke="black" strokeWidth={sw} strokeLinecap="round" />
          </mask>
        </defs>
        <path d={STONE} fill="currentColor" stroke="currentColor" mask={`url(#${mask})`} />
        <path d="M40 212h176" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      {weight === "duotone" && <path d={STONE} fill="currentColor" opacity="0.2" stroke="none" />}
      <path d={STONE} />
      <path d="M128 92v72M104 116h48M40 212h176" />
    </svg>
  );
}

export default GraveIcon;
